module.exports = __webpack_public_path__ + "static/media/a_of_clubs.cb47b0a3.png";